// extracted by mini-css-extract-plugin
export default {"base":"SquareButtonLink_base__Hyu4Z","isActive":"SquareButtonLink_isActive__nJmfX","outline":"SquareButtonLink_outline__PLqzG","hasBorder":"SquareButtonLink_hasBorder__vkcun"};